/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliverFeeInternationRespVo } from './GetDeliverFeeInternationRespVo';
import {
    GetDeliverFeeInternationRespVoFromJSON,
    GetDeliverFeeInternationRespVoFromJSONTyped,
    GetDeliverFeeInternationRespVoToJSON,
    GetDeliverFeeInternationRespVoToJSONTyped,
} from './GetDeliverFeeInternationRespVo';

/**
 * 
 * @export
 * @interface ResponseGetDeliverFeeInternationRespVo
 */
export interface ResponseGetDeliverFeeInternationRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseGetDeliverFeeInternationRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseGetDeliverFeeInternationRespVo
     */
    message?: string;
    /**
     * 
     * @type {GetDeliverFeeInternationRespVo}
     * @memberof ResponseGetDeliverFeeInternationRespVo
     */
    data?: GetDeliverFeeInternationRespVo;
}

/**
 * Check if a given object implements the ResponseGetDeliverFeeInternationRespVo interface.
 */
export function instanceOfResponseGetDeliverFeeInternationRespVo(value: object): value is ResponseGetDeliverFeeInternationRespVo {
    return true;
}

export function ResponseGetDeliverFeeInternationRespVoFromJSON(json: any): ResponseGetDeliverFeeInternationRespVo {
    return ResponseGetDeliverFeeInternationRespVoFromJSONTyped(json, false);
}

export function ResponseGetDeliverFeeInternationRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetDeliverFeeInternationRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : GetDeliverFeeInternationRespVoFromJSON(json['data']),
    };
}

export function ResponseGetDeliverFeeInternationRespVoToJSON(json: any): ResponseGetDeliverFeeInternationRespVo {
    return ResponseGetDeliverFeeInternationRespVoToJSONTyped(json, false);
}

export function ResponseGetDeliverFeeInternationRespVoToJSONTyped(value?: ResponseGetDeliverFeeInternationRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': GetDeliverFeeInternationRespVoToJSON(value['data']),
    };
}

